import React, { useEffect, useState } from "react";
import avatar from "../../assets/images/profile.png";
import { withRouter } from "react-router-dom";
import { removeUser } from "../../components/shared/utils";
import { compose } from "redux";
import { connect } from "react-redux";
import _ from "lodash";
import cx from "classnames";
import Socket from "../../socket/socket";
import * as paramsAction from "../../redux/gameParams/actions";
import Alert from "../shared/common/alert";

import crossIcon from "../../assets/images/slide-kick/cross-iconn.png";

function SlideKickPlayers(props) {
  const room_data = _.get(props, "gameReducer.roomObj");
  const status = _.get(room_data, "game_state.status");
  const users = _.get(room_data, "users");
  const host_user_id = _.get(room_data, "host_user_id");

  const delPlayer = (data) => {
    const roomObj = props.gameReducer.roomObj;
    removeUser(roomObj, data);
  };

  // useEffect(() => {
  //   if (status == "Presenting") {
  //     props.history.push("/slidekick");
  //   }
  // }, [status]);

  useEffect(() => {
    return Socket.addListener("update-status", async (res) => {
      props.history.push("/slidekick");
    });
  }, []);

  useEffect(() => {
    if (status != "Joining") {
      let gameObj = props.gameReducer;
      let dataObj = {
        gameName:
          gameObj.gameName !== "" ? gameObj.gameName : gameObj.roomObj.game_code
      };
      props.getGameData(dataObj);
      if (Object.keys(props.paramsReducer.gameObj).length > 0) {
        props.history.push("/slidekick");
      }
    }
  }, [status, props.paramsReducer.gameObj]);

  const on_start_game = () => {
    if (users && users.length < 2) {
      Alert(400, "Need at least 2 players to start the game");
      return;
    } else {
      let host_joined = false;
      for (let user of users) {
        if (user.user_id === host_user_id) {
          host_joined = true;
        }
      }
      if (!host_joined) {
        Alert(400, "Wait for the Host to join the game!");
        return;
      } else {
        let data = {
          action: "update-status",
          roomId: room_data.id
        };
        Socket.sendMessage(data);
      }
    }
  };

  const imgError = (e) => {
    e.target.src = avatar;
  };

  return (
    <>
      <div className="container">
        <h1>Users</h1>
        <div className="slideKickPlayers">
          {users &&
            users.length > 0 &&
            users.map((item) => (
              <div className="player-wrapper">
                <div
                  className={cx("player", {
                    host: item.user_id === host_user_id
                  })}
                >
                  <img
                    src={item?.profile_image ? item.profile_image : avatar}
                    alt="profile"
                    onError={(e) => imgError(e)}
                  />
                  <h2>{item.display_name}</h2>
                  <button className="btn" onClick={() => delPlayer(item)}>
                    {/* <i className="fas fa-times-square fa-2x"></i> */}
                    <img src={crossIcon} className="cross-img" alt="" />
                  </button>
                </div>
              </div>
            ))}
        </div>
      </div>
      <div className="footer d-flex justify-content-between">
        <button className="btn btn-close" onClick={() => props.onBack()}>
          Close Room
        </button>
        <button className="btn btn-start" onClick={on_start_game}>
          START
        </button>
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer
});

const mapDispatchToProps = (dispatch) => {
  return {
    getGameData: (data) => dispatch(paramsAction.getGameData(data))
  };
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(SlideKickPlayers);
